<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-empresa') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"    
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="addEmpresaProduto"
                    :disabled="empresasSelecionados.length === 0 && !isEdit"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="columns">
            <div class="column is-6">
                <v-money
                    :id="generateId(1)"
                    ref="valorInput"
                    title="multiplicadorweb"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    :required="true"
                    :value="multiplicadorweb"
                    @input="multiplicadorUpdate"
                    :invalid="isNull(multiplicadorweb)"
                    :max="9999999"
                    tooltipLabel="informacao-multiplicador"
                    tooltipSize="is-small"
                />
            </div>
            <div class="column is-6">
                <v-money
                    :id="generateId(2)"
                    ref="valorInput"
                    title="multiplicadortrocaweb"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    :required="true"
                    :value="multiplicadortrocaweb"
                    @input="multiplicadortrocaUpdate"
                    :invalid="isNull(multiplicadortrocaweb)"
                    :max="9999999"
                    tooltipLabel="informacao-multiplicador-troca"
                    tooltipSize="is-small"
                />
            </div>
        </div>
        <div class="search-and-filter" v-if="!isEdit">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
        </div>

        <div class="registry-wrapper" v-if="!isEdit">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="empresas"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="empresasSelecionados"
                :custom-is-checked="(selecionados, linha) => selecionados.idempresa === linha.idempresa"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AssProdutoEmpresaService from "@/services/vendas/empresa/abas/AssProdutoEmpresaService";

// MENSAGENS
import Message from "@/models/Message";

export default {
    props: {
        idProduto: 0,
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            service: new AssProdutoEmpresaService(this.$http, this.$router),
            empresas: [],
            isLoading: false,
            isEmpty: false,
            isEdit: false,
            assproutoempresa: {},
            fields: [
                {key: 'nome', width: null, sortable: true, sortFn: null},
            ],
            empresasSelecionados: [],
            idproduto: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            multiplicadorweb: 1,
            multiplicadortrocaweb:1,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            msgs: [],
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        if(this.selected){
            this.isEdit = true
            this.loadAssEmpresaProduto()
        }
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.service
            .findNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idProduto,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.empresas = value;
                this.isEmpty = this.empresas.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },

        generateId(numberId){
            return this.$route.name+'-produto-'+numberId;
        },
        multiplicadorUpdate(value){
            this.multiplicadorweb = value;
        },
        multiplicadortrocaUpdate(value){
            this.multiplicadortrocaweb = value;
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    idempresa: m.idempresa,
                    nome: m.nome,
                    rsocial: m.rsocial,
                    multiplicadorweb: this.multiplicadorweb,
                    multiplicadortrocaweb: this.multiplicadortrocaweb,
                };
            });
        },
        loadAssEmpresaProduto() {
            this.loadingPacote = true
            this.service
                .find(this.selected.idassprodutoempresa)
                .then((body) => this.mapEmpresaProduto(body.content))
                .finally(() => {
                    this.isLoading = false
                })
        },
        mapEmpresaProduto(item) {
            this.assproutoempresa.idassprodutoempresa = item.idassprodutoempresa
            this.assproutoempresa.idempresa = item.idempresa
            this.assproutoempresa.nome = item.nome
            this.assproutoempresa.rsocial = item.rsocial
            this.multiplicadorweb = item.multiplicadorweb
            this.multiplicadortrocaweb = item.multiplicadortrocaweb
        },
        mapOnSave(itens) {
            return itens.map(m => {
                return {
                    idproduto: this.idProduto,
                    idempresa: m.idempresa,
                    nome: m.nome,
                    rsocial: m.rsocial,
                    multiplicadorweb: this.multiplicadorweb,
                    multiplicadortrocaweb: this.multiplicadortrocaweb,
                };
            });
        },
        mapOnUpdate() {
            return {
                idassprodutoempresa: this.assproutoempresa.idassprodutoempresa,
                idproduto: this.idProduto,
                idempresa: this.assproutoempresa.idempresa,
                nome: this.assproutoempresa.nome,
                rsocial: this.assproutoempresa.rsocial,
                multiplicadorweb: this.multiplicadorweb,
                multiplicadortrocaweb: this.multiplicadortrocaweb,
            };
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        addEmpresaProduto(){
            if(this.isEdit){
                this.update()
            } else {
                this.save()
            }
        },
        update() {
            this.isLoading = true;

            const payload = this.mapOnUpdate();

            this.$axios.post(`/ven/empresa/assprodutoempresa/update`, payload)
            .then(response => {

                const data = response.data;

                // Exemplo: backend retorna { success, message, content }
                if (!data || data.content === null) {
                    this.msgs.push(new Message("error", data.message || 'Erro inesperado', true));
                    return;
                }

                // Sucesso
                this.onFecharModal();
                this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
            })
            .catch(error => {
                let msg = 'msg-erro-load';

                if (error.response && error.response.data) {
                    msg = error.response.data.message || msg;
                }

                this.msgs.push(new Message("alert", msg, true));
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        save() {
            if (this.empresasSelecionados.length > 0) {
                this.isLoading = true;
                this.service.salvarAssociados(this.mapOnSave(this.empresasSelecionados))
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.onFecharModal()
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-usuario', true));
                this.isLoading = false;
            }
        },
        onFecharModal(){
            this.isEdit = false
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>